<script setup>
import ContentHeader from "@/components/Dashboard/ContentHeader.vue";
import FilterOptions from "@/components/Dashboard/Devices/WindTagDevices/WindTagFilterOptions.vue";
import FilteredDevices from "@/components/Dashboard/Devices/WindTagDevices/WindTagFilteredDevices.vue";
</script>
<template>
  <ContentHeader :name="'WindTag Devices'" />
  <FilterOptions />
  <FilteredDevices />
</template>
